import * as React from "react";
import DocumentItem from "./DocumentItem";
import { IDocumentModel } from "./IDocumentModel";

interface DocumentListProps {
    documents: IDocumentModel[];
    onRemoveAttachment: (guid: string) => void;
}

const DocumentList: React.FC<DocumentListProps> = props => {
    return (
        <div className="document-list-wrapper">
            {props.documents &&
                props.documents.length > 0 &&
                props.documents.map((doc, index) => {
                    return (
                        <DocumentItem
                            key={index}
                            index={index}
                            document={doc}
                            onRemoveAttachment={props.onRemoveAttachment}
                        />
                    );
                })}
        </div>
    );
};

export default DocumentList;
